import firebase from "firebase/app";
import "firebase/storage";
import { fields, ISignUp } from "../constants/fields";
import { MappedSignUp } from "../pages/AdminHome";
import { ISchool } from "./firebase";
import * as XLSX from 'xlsx';
import { convertTimestamp } from "../utils/convert";

interface IMappedFiles {
  [key: string]: string
}

type ExportFilters = {
  school?: string;
  program?: number
}

// Takes a list of document id's and deletes them one by one.
export async function bulkDelete(docsToDelete: string[]) {

  let snapshot = await firebase.firestore().collection('sign_ups')
    .where(firebase.firestore.FieldPath.documentId(), 'in', docsToDelete).get();

  for (const doc of snapshot.docs) {
    const storageRef = firebase.storage().ref(doc.id);
    const files = (await storageRef.listAll()).items;
    await Promise.all(files.map(file => file.delete()));

    await doc.ref.delete();
  }

  return true;
}

let exportCategories = [
  fields.school,
  fields.createDate,
  fields.student,
  fields.residence,
  fields.parents,
  fields.identification,
  fields.shirtSize,
  fields.certificates,
  fields.malica,
  fields.books,
  fields.misc,
  fields.commute,
  fields.odlocba,
]

// ! KEEP THIS FALSE FOR PRODUCTION
const bSkipImageLinkGenerationProcess = false;

// ------------------------------------------------------------------------------------
// Big thanks to Stack Overflow, as always:
// https://stackoverflow.com/questions/14964035/how-to-export-javascript-array-info-to-csv-on-client-side/63744993#63744993
// ------------------------------------------------------------------------------------
export async function exportSignUps(schools: ISchool[], signUps: ISignUp[], mappedData: MappedSignUp[], filters: ExportFilters) {

  // Get a list of all column names and put them in a sequence
  let columnNames: string[] = [];
  for(let cat of exportCategories) {
    for(let entry in cat) {
      let _entry = cat[entry]
      let prefix = (_entry.labelPrefix) ? `${_entry.labelPrefix} ` : '';
      columnNames.push( prefix + (_entry.alternativeLabel ?? _entry.label) )
    }
  }

  let rows: any = [
    // columnNames
  ];

  let filteredSignUps: ISignUp[] = [];
  if(filters?.school) {
    let targetSchool = schools.find(_school => _school.short == filters?.school);

    if(targetSchool && filters?.school != 'all') {
      let schoolId = targetSchool.id;
      
      signUps = signUps.filter(_su => _su.school == schoolId);

      if(filters?.program && typeof filters.program != 'number') {

        let targetProgram = targetSchool?.programs.indexOf(filters.program);

        signUps = signUps.filter(_su => _su.program == targetProgram);
      }
    }
  }

  // Go through every sign up and map its data into the array.
  for(let signUp of signUps) {


    let row: string[] = [];
    // let ref = firebase.storage().ref(signUp.id);
    // let files = (await ref.listAll()).items;

    // Fetch the download URL for every file of the signUp
    let mappedFiles: IMappedFiles = {};
    if(!bSkipImageLinkGenerationProcess) {

      let ref = firebase.storage().ref(signUp.id);
      let files = (await ref.listAll()).items;

      for(let file of files) {
        let url = await file.getDownloadURL();
        mappedFiles[file.name] = url;
      }
    }
   
    for(let cat of exportCategories) {
      for(let entry in cat) {
        let _entry = cat[entry];

        // @ts-expect-error: frick u ts
        let value: any = signUp[_entry.field];

        // The field is present
        if(typeof value != 'undefined' || value != null) {
          if(_entry.field == 'school') {
            let school = schools.find(_school => _school.id == signUp['school'])?.short;
            row.push(school ?? '');
          }
          else if(_entry.field == 'program') {
            let program = schools.find(_school => _school.id == signUp['school'])?.programs[value];
            row.push(program ?? '');
          } else if(_entry?.lookup) {
            // @ts-expect-error: frick u ts
            row.push(_entry.lookup[value])
          } else if (_entry?.type == 'date') {

            // @ts-expect-error: frick u ts
            row.push(convertTimestamp(value, _entry?.datePrecise ?? false))
          } else if (_entry?.type == 'file') {
            row.push(mappedFiles[value]);
          } else {
            row.push(`${value}`);
          }
          
          // row.push(signUp[_entry.field]);
        } else {
          row.push('');
        }
      }
    }

    rows.push(row);
  }

  // Ustvari Excel delovni list
  const ws = XLSX.utils.aoa_to_sheet([columnNames, ...rows]);

  // Nastavi klikabilne hyperlinke za celice z URL-ji (polja tipa 'file')
  let fileFieldIndices: number[] = [];
  let colIndex = 0;
  for (let cat of exportCategories) {
    for (let entry in cat) {
      if ((cat as any)[entry]?.type === 'file') {
        fileFieldIndices.push(colIndex);
      }
      colIndex++;
    }
  }

  rows.forEach((row: string[], rowIndex: number) => {
    fileFieldIndices.forEach(colIdx => {
      const url = row[colIdx];
      if (url) {
        const cellAddress = XLSX.utils.encode_cell({ r: rowIndex + 1, c: colIdx });
        if (ws[cellAddress]) {
          ws[cellAddress].l = { Target: url, Tooltip: url };
        }
      }
    });
  });

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Prijave");
  XLSX.writeFile(wb, "izvoz.xlsx");
}